// Function to handle visibility based on checked input
function toggleElement() {
    const allTogglers = document.querySelectorAll(`.toggler [aria-controls]`)
    
    allTogglers.forEach(togglerInput => {
        const togglerTarget = togglerInput.getAttribute('aria-controls')
        const isChecked = togglerInput.checked
        
        const element = document.getElementById(togglerTarget)
        if (element) {
            if (isChecked) {
                // Show the element
                element.classList.remove('d-none')
                togglerInput.setAttribute('aria-expanded', 'true')

                // Check if the element is an "article-text" block
                if(element.classList.contains('article-text')){
                    setTimeout(() => {
                        handleIndexComponent()
                        element.querySelector('.index-component').classList.add('index-component--current')
                      }, "150");
                }
            } else {
                // Hide the element
                element.classList.add('d-none')
                togglerInput.setAttribute('aria-expanded', 'false')

                // Check if the element is an "article-text" block
                if(element.classList.contains('article-text')){
                    setTimeout(() => {
                        element.querySelector('.index-component').classList.remove('index-component--current')
                    }, "150");
                }
            }
        }
    })
}

// Function to initialize visibility based on checked inputs
function initializeVisibility() {
    const togglerGroups = document.querySelectorAll('.toggler [aria-controls]')
    togglerGroups.forEach(input => {
        input.addEventListener('change', function () {
            toggleElement()
        })

        // Initial check for visibility
        toggleElement()
    })
}

// Run the initialization after the page has loaded
window.addEventListener('load', initializeVisibility)